import { useState } from 'react';
import { toast } from 'react-toastify';

import { SaveNumberModal } from '../SaveNumberModal';

const EMPTY_STRING = '';

export const UnsavedNumberModal = ({
  open,
  onClose,
  phoneNumber,
  onChangeIndex,
  onChangeContact,
  contact,
  onChangePhoneNumber,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onAccept = async () => {
    setIsSubmitting(true);
    const defaultValues = {
      contactId: contact.contactId,
      company: contact.company,
      contact: contact.contact ?? EMPTY_STRING,
      title: contact.title ?? EMPTY_STRING,
      industry: contact.industry ?? EMPTY_STRING,
      country: contact.country ?? EMPTY_STRING,
      state: contact.state ?? EMPTY_STRING,
      city: contact.city ?? EMPTY_STRING,
      address: contact.address ?? EMPTY_STRING,
      website: contact.website ?? EMPTY_STRING,
      email: contact.email ?? EMPTY_STRING,
      linkedin: contact.linkedin ?? EMPTY_STRING,
    };

    try {
      const response = await fetch('/call-contact-update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...defaultValues,
          phoneNumbersToAdd: [{ phoneNumber, isBestPhoneNumber: 0 }],
        }),
      });

      if (response.status !== 200) throw new Error();

      const data = await response.json();

      onChangeContact({
        ...contact,
        phoneNumbers: data.record.PhoneNumbers,
      });
      onChangePhoneNumber('');
      setIsSubmitting(false);
      onClose();
      onChangeIndex(0);
    } catch {
      setIsSubmitting(false);
      toast.error("Can't save Phone Number, please try again!", {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const onReject = () => {
    onChangePhoneNumber('');
    onClose();
    onChangeIndex(0);
  };

  return (
    <SaveNumberModal
      open={open}
      onClose={onClose}
      disabled={isSubmitting}
      onAccept={onAccept}
      onReject={onReject}
      description="Going back to lead will result into deleting number dialled."
    />
  );
};
